export enum LocalStorageKeysEnum {
  IsMenuExpanded = 'isMenuExpanded',
  IsLocationPinned = 'isLocationPinned',
  IsLastRunDateSelected = 'isLastRunDateSelected',
}
